<template>
  <div>
    <a-popover
      v-model="visible"
      trigger="click"
      placement="bottomRight"
      overlayClassName="header-notice-wrapper"
      :getPopupContainer="() => $refs.noticeRef.parentElement"
      :autoAdjustOverflow="true"
      :arrowPointAtCenter="true"
      :overlayStyle="{ width: '500px', top: '50px', right: '0px', left: 'auto', position: 'fixed' }"
    >
      <template slot="content">
        <a-spin :spinning="loading">
          <a-tabs v-model="active" @change="changeTab">
            <a-tab-pane tab="未读" key="1"></a-tab-pane>
            <a-tab-pane tab="已读" key="2"></a-tab-pane>
          </a-tabs>
          <div style="min-height: 200px; max-height: 90vh; overflow-y: auto">
            <a-list>
              <div
                v-if="showLoadingMore"
                slot="loadMore"
                :style="{ textAlign: 'center', marginTop: '12px' }"
              >
                <a-spin v-if="loadingMore" />
                <a-button v-show="totalPages > page && !loadingMore" @click="onLoadMore" type="link">
                  加载更多
                </a-button>
                <span v-show="totalPages <= page && !loadingMore" style="color: #d7d7d7">———— 我是底线 ————</span>
              </div>

              <a-list-item
                v-for="(x, idx) in list"
                :key="idx"
                v-show="active === '1' ? !x.read : x.read"
                @click="read(x)"
                :style="{cursor: x.read ? 'default':'pointer', }">
                <!--                <a slot="actions">edit</a>-->
                <!--                <a slot="actions">more</a>-->
                <!--                <a slot="extra">2025-11-12 13:20</a>-->
                <a-list-item-meta>
                  <div slot="title" class="flex">
                    <span style="font-size: 16px;font-weight: bold;margin-right: 10px; color: #111827">{{ x.title }}</span>
                    <a-tag :color="getMessageType(x.systemType).color">{{ getMessageType(x.systemType).name }}</a-tag>
                    <span class="flex1"></span>
                    <span style="font-size: 13px; font-weight:100;color: #9CA3AF">{{ x.updated }}</span>
                  </div>
                  <div slot="description" style="color: #6B7280">{{ x.content }}</div>
                </a-list-item-meta>
                <!--                <div>content</div>-->
              </a-list-item>

            </a-list>
          </div>
          <div style="display: flex; gap:10px;margin-top: 10px; padding-top: 10px;border-top: 1px solid #E9EBEE">
            <a-button style="flex: 1" @click="allRead">全部已读</a-button>
            <a-button style="flex: 1" type="link" @click="() => {this.visible = false}">关闭</a-button>
          </div>
        </a-spin>
      </template>
      <span @click="fetchNotice" class="header-notice" ref="noticeRef">
        <a-badge :count="unReadCount">
          <a-icon style="font-size: 16px; padding: 4px" type="bell" theme="filled"/>
        </a-badge>
      </span>
    </a-popover>

    <!-- 版本更新提示 Modal -->
    <a-modal
      v-model="versionModalVisible"
      title="版本更新提示"
      :closable='false'
      :maskClosable='false'
      @ok="handleUpdate"
      @cancel="handleCancel"
      :okButtonProps="{ props: { disabled: downloadProgress !== 0 } }"
      :cancelButtonProps="{ props: { disabled: downloadProgress !== 0 } }"
    >
      <div style='text-align: center;'>
        <p>当前版本号：{{ currentVersion }}</p>
        <p>最新版本号：{{ latestVersion }}</p>
        <div style=' margin-top: 20px; margin-bottom: 20px' v-show='downloadProgress'>
          <p>下载进度：</p>
          <a-progress type="circle" :percent="downloadProgress"/>
        </div>
      </div>

      <template slot="footer">
        <div style="display: flex; justify-content: space-between;">
          <button
            class="custom-btn custom-btn-secondary"
            @click="handleCancel"
            :disabled="downloadProgress !== 0"
          >
            {{ downloadProgress !== 0 ? '正在更新...' : '稍后更新' }}
          </button>
          <button
            class="custom-btn custom-btn-primary"
            @click="handleUpdate"
            :disabled="downloadProgress !== 0"
          >
            {{ downloadProgress !== 0 ? '正在下载...' : '立即更新' }}
          </button>
        </div>
      </template>
    </a-modal>
  </div>
</template>

<script>

export default {
  name: 'HeaderNotice',
  data () {
    return {
      active: '1',
      loading: false,
      visible: false,
      loadingMore: false,
      showLoadingMore: true,
      page: 1,
      pageSize: 5,
      total: 100,
      totalPages: 10,
      list: [],
      unReadCount: 0,
      versionModalVisible: false,
      currentVersion: '',
      latestVersion: '',
      downloadProgress: 0
    }
  },
  mounted () {
    this.getVersion()
    this.getUnreadCount()
    setInterval(() => {
      this.getUnreadCount()
    }, 10000)

    // 添加监听下载进度的事件
    if (process.env.VUE_APP_ELECTRON) {
      const { ipcRenderer } = require('electron')
      ipcRenderer.on('download-progress', (event, progress) => {
        this.downloadProgress = progress
      })

      ipcRenderer.on('update-error', (event, message) => {
        this.downloadProgress = 0
        this.$message.error('更新失败: ' + message)
      })
    }
  },
  methods: {
    getVersion () {
      if(!process.env.VUE_APP_ELECTRON) return
      const { getLatestVersion } = require('@/api/login')
      getLatestVersion().then(res => {
        if (res.success === 1) {
          this.latestVersion = res.dataMap.data.version
          this.currentVersion = require('/package.json').version
          this.downloadUrl = res.dataMap.data.fileUrl

          if (this.latestVersion !== this.currentVersion) {
            this.versionModalVisible = true
          }
        }
      }).catch(err => {
        console.error('获取版本信息失败', err)
      })
    },

    handleUpdate() {
      if(this.downloadProgress !== 0) return
      this.downloadAndInstall(this.downloadUrl)
      // 不隐藏模态框，显示下载进度
    },

    handleCancel() {
      if(this.downloadProgress !== 0) return
      console.log('用户取消更新')
      this.versionModalVisible = false
      this.downloadProgress = 0
    },

    downloadAndInstall(fileUrl) {
      if(process.env.VUE_APP_ELECTRON) {
        const { ipcRenderer } = require('electron')
        ipcRenderer.send('download-and-install', fileUrl)
      } else {

      }
    },

    getUnreadCount () {
      const { sysMessageCountUnread } = require('@/api/message')
      sysMessageCountUnread().then(res => {
        if (res.success === 1) {
          this.unReadCount = res.dataMap.data
        } else {
          this.unReadCount = 0
        }
      }).catch(() => {
        this.unReadCount = 0
      })
    },
    getData () {
      const { sysMessageList } = require('@/api/message')
      this.loading = true
      return new Promise((resolve, reject) => {
        sysMessageList({
          page: this.page,
          pageSize: this.pageSize,
          isRead: this.active === '1' ? 0 : 1
        }).then(res => {
          this.loading = false
          if (res.success === 1) {
            const r = res.dataMap.data
            // this.total = r.total
            // this.totalPages = r.totalPages
            // if (this.page === 1) {
            //   this.list = [...r.list]
            // } else {
            //   this.list = this.list.concat([...r.list])
            // }
            resolve(r)
          } else {
            reject(new Error('获取消息错误'))
          }
        }).catch(() => {
          this.loading = false
          reject(new Error('获取消息错误'))
        })
      })
    },
    fetchNotice () {
      console.log('fetchNotice')
      if (!this.visible) {
        this.list = []
        this.page = 1
        this.total = 100
        this.totalPages = 10
        this.getData().then(res => {
          console.log('res', res)
          this.total = res.total
          this.totalPages = res.totalPages
          this.list = [...res.list]
        })
      } else {
        // this.loading = false
      }
      this.visible = !this.visible
    },
    changeTab (e) {
      this.list = []
      this.page = 1
      this.total = 100
      this.totalPages = 10
      this.getData().then(res => {
        console.log('res', res)
        this.total = res.total
        this.totalPages = res.totalPages
        this.list = [...res.list]
      })
    },
    onLoadMore () {
      console.log('onLoadMore')
      this.page++
      // this.loadingMore = true
      this.getData().then(res => {
        // this.data = this.data.concat(res.results)
        this.list = this.list.concat([...res.list])
        this.total = res.total
        this.totalPages = res.totalPages
        // this.loadingMore = false
        this.$nextTick(() => {
          // window.dispatchEvent(new Event('resize'))
        })
      }).catch(() => {
        this.page--
      })
    },
    allRead () {
      const { sysMessageAllRead } = require('@/api/message')
      sysMessageAllRead({}).then(res => {
        if (res.success === 1) {
          this.$message.success('批量操作成功。')
          this.fetchNotice()
        } else {
        }
      }).catch(() => {
      })
    },
    read (x) {
      if (x.read) return false
      const { sysMessageBatchUpdateReadStatus } = require('@/api/message')
      sysMessageBatchUpdateReadStatus({ ids: [x.id], isRead: true }).then(res => {
        if (res.success === 1) {
          this.$message.success('已读成功。')
          x.read = true
          this.unReadCount = res.dataMap.data
        } else {
        }
      }).catch(() => {
      })
    },
    getDetail (x) {
      const { sysMessageGetById } = require('@/api/message')
      sysMessageGetById({ id: x.id }).then(res => {
        if (res.success === 1) {
          this.$info({
            title: x.title,
            content: x.content,
            icon: '',
            onOk: () => {
            },
            onCancel () {
            }
          })
        } else {
        }
      }).catch(() => {
      })
    },
    getMessageType (type) {
      const obj = {
        color: 'blue',
        name: '系统消息'
      }
      switch (type) {
        case 'system':
          obj.color = 'blue'
          obj.name = '系统消息'
          break
        case 'manage':
          obj.color = 'purple'
          obj.name = '业务消息'
          break
        default:
      }
      return obj
    }
  },
  beforeDestroy() {
    // 清理事件监听器
    if (process.env.VUE_APP_ELECTRON) {
      const { ipcRenderer } = require('electron')
      ipcRenderer.removeAllListeners('download-progress')
      ipcRenderer.removeAllListeners('update-error')
    }
  }
}
</script>

<style lang="css">
.header-notice-wrapper {
  top: 50px !important;
}
</style>
<style lang="less" scoped>
.header-notice {
  display: inline-block;
  transition: all 0.3s;

  span {
    vertical-align: initial;
  }
}

::v-deep {
  .ant-tag {
    border-radius: 30px;
    border-width: 0;
    padding-left: 10px;
    padding-right: 10px;
  }

  .ant-list .ant-list-item {
    padding-left: 10px;
    padding-right: 10px;

    &:hover {
      background-color: #FBFBFC;
    }
  }
}

.custom-btn {
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  border: 1px solid transparent;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.custom-btn-primary {
  background-color: #1890ff;
  color: white;

  &:hover:not(:disabled) {
    background-color: #40a9ff;
  }
}

.custom-btn-secondary {
  background-color: #f0f0f0;
  color: #333;

  &:hover:not(:disabled) {
    background-color: #d9d9d9;
  }
}
</style>